module.exports = __webpack_public_path__ + "static/media/DSC01802.ce810314.jpeg";